import React, {useEffect, useState} from 'react'
import Button from '@components/Button'
import logger from '@helpers/logger'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import Loading from '@packages/justo-parts/lib/components/Loading'
import {useMutate} from 'apollo-hooks'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

import verifiedUser, {SpoonityValidUser} from '../query/verifiedUser'

export default function ValidateUser({
  loyaltyAuthenticatedToken,
  submit,
  email,
  setShowVerificationCode
}) {
  const [verificationCode, setVerificationCode] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const mutate = useMutate()

  const {spoonityValidUser}: {spoonityValidUser: SpoonityValidUser} = useQuery({
    query: verifiedUser,
    variables: {
      sessionKey: loyaltyAuthenticatedToken
    },
    omit: !loyaltyAuthenticatedToken,
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    if (spoonityValidUser?.isValidated) {
      const submitLoyalty = async () => {
        await submit({code: email, sessionKey: loyaltyAuthenticatedToken})
      }
      submitLoyalty()
    }
  }, [spoonityValidUser?.isValidated])

  async function validateUser() {
    try {
      //We validate the user with session and verificationCode and the validateWallet
      const {spoonityActivateUser} = await mutate({
        mutation: gql`
          mutation activateUser($sessionKey: String, $token: String) {
            spoonityActivateUser(sessionKey: $sessionKey, token: $token)
          }
        `,
        variables: {
          sessionKey: loyaltyAuthenticatedToken,
          token: verificationCode
        }
      })
      if (spoonityActivateUser) {
        await submit({code: email, sessionKey: loyaltyAuthenticatedToken})
        setShowVerificationCode(true)
      }
    } catch (error) {
      logger.warn('error validatingUser spoonity', {error})
    }
  }

  async function resendVerificationCode() {
    try {
      setLoading(true)
      await mutate({
        mutation: gql`
          mutation resendVerificationCode($sessionKey: String) {
            spoonityResendVerificationCode(sessionKey: $sessionKey)
          }
        `,
        variables: {
          sessionKey: loyaltyAuthenticatedToken
        }
      })
    } catch (error) {
      logger.warn('error resendingVerificationCode spoonity', {error})
    } finally {
      setLoading(false)
    }
  }

  if (!spoonityValidUser || spoonityValidUser?.isValidated) return null

  return (
    <>
      <Field
        fieldName="verificationCode"
        type={Text}
        value={verificationCode}
        disabled={false}
        label="Código de verificación"
        onChange={code => setVerificationCode(code)}
      />
      <Button
        fullWidth
        primary
        onClick={async () => {
          await validateUser()
        }}
        disabled={!verificationCode}
        loading={false}>
        Confirmar
      </Button>
      <br />
      {loading ? (
        <div className="text-center">
          <Loading />
        </div>
      ) : (
        <div
          className="text-blue-600 text-center cursor-pointer"
          onClick={async () => {
            resendVerificationCode()
          }}>{`Reenviar código de verificación`}</div>
      )}
    </>
  )
}
